<template>
  <div>
    <Navbar />
    <div class="columns">
      <SideBar class="menu-sidebar"/>
      <section class="qi-content">
        <header>
          <h1>Selecione a Turma</h1>
          <p> Data mínima para rematrícula: {{course.DATAMINREM}}</p>
        </header>

        <vs-row>
          <NewSale />
        </vs-row>

        <vs-row vs-w="12" v-if="error != ''">
          <vs-col vs-w="8">
            <vs-card>
              <vs-row vs-w="12">
                {{ error }}
              </vs-row>
              <vs-row vs-w="12">
                <vs-col justify="space-around" align="right">
                  <vs-button @click="goTo('/reenrollment')">
                    Voltar para a tela inicial
                  </vs-button>
                </vs-col>
              </vs-row>
            </vs-card>
          </vs-col>
        </vs-row>

        <vs-row
          v-else
          v-for="(classItem, index) in classes"
          :key="index"
          vs-w="12"
        >
          <vs-col>
            <vs-card style="height: 240px; box-shadow: 0px 0px 2px 1px #888888;">
              <div slot="header">
                <h3>
                  <strong>{{ classItem.NOMETURMA }} </strong>
                </h3>
              </div>
              <div>
                <p><strong> Polo/Filial: </strong> {{ classItem.CODFILIAL }}</p>
                <p>
                  <strong> Código da Turma: </strong> {{ classItem.CODTURMA }}
                </p>
                <p>
                  <strong> Data de Início: </strong>
                  {{ classItem.DTINICIAL | moment }}
                </p>
              </div>
              <div v-if="offer.MODALIDADE != 'D'">
                <p><strong> Horário: </strong> {{ classItem.HORARIO }}<br>
                <strong> Turno: </strong> {{ classItem.TURNO }}</p>
              </div>
              <div>
                <p>{{ classItem.NOMECOMERCIAL }}</p>
              </div>
              <div>
                <vs-button
                  style="width: 100%; margin: 15px 0 10px 0;"
                  icon="local_offer"
                  @click="selectClass(classItem)"
                >
                  Selecionar Esta Turma
                </vs-button>
              </div>
            </vs-card>
          </vs-col>
        </vs-row>
      </section>
    </div>
    <ConsultValidationRem />
  </div>
</template>

<script>
import Course from "../services/courses";
import ConsultValidationRem from "../components/ConsultValidationRem.vue";
import { formatDateToUSA, getStepsInformation, updateStepsInformation } from '../helpers';
import moment from "moment";

export default {
  name: "ClassReEnrollment",
  components: {
    ConsultValidationRem
  },
  data: () => ({
    ra: "",
    classes: [],
    error: "",
    offer: null,
    course: null,
    electives: null,
  }),

  methods: {
    goTo( route ){
      this.$router.push(route);
    },


    selectClass(classData) {
      updateStepsInformation({classData});
      this.$router.push("/subjectsreenrollment");
    },
  },

  filters: {
    moment: function(date) {
      moment.locale("pt-br");
      return moment(date).format("DD/MM/YYYY");
    },
  },

  create(){

  },

  mounted() {
    const { offer, course, electives } = getStepsInformation();
    this.offer = offer;
    this.course = course;
    this.electives = electives;
    let hasElectives = [];
    let qtd = 0;
    if (this.electives) {
      this.electives.forEach((element) => {
        qtd = hasElectives.push(element.CODDISC);
      });
    }
    for (var i = qtd; i < 3; i++) {
      hasElectives.push(0);
    }

    this.$vs.loading({
      color: "danger",
    });

    let formatDate = formatDateToUSA(this.course.DATAMINREM)

    new Course()
      .getClassesRem(
        this.offer.CODCURSO,
        this.offer.IDHABILITACAOFILIAL,
        this.offer.CODCAMPUS,
        hasElectives[0],
        hasElectives[1],
        hasElectives[2],
        this.offer.IDCLASSIFICACAO,
        formatDate,
        this.course.RA
      )
      .then(({ data }) => {
        this.classes = Array.isArray(data) ? data : [data];
      })
      .catch(({ response }) => {
        if (response && response.data) {
          this.error = response.data.error;
        }
      })
      .finally(() => {
        this.$vs.loading.close();
      });
  },
};
</script>
